import React from "react";
import Sidebar from "@/components/Sidebar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Sidebar />
      <main className="ml-64 px-10 py-8">{children}</main>
    </div>
  );
}
